//@flow
import * as Immutable from 'immutable';

import {
    BusinessUnitList,
    BusinessUnit,
    BusinessUnitId
} from 'common/models/flow/BusinessUnits';
import type {
    BusinessUnitListModelType,
    BusinessUnitModelType,
    BusinessUnitIdModelType
} from 'common/models/flow/BusinessUnits';

class InternalBusinessUnitList extends BusinessUnitList {
    static fromJS(json: BusinessUnitListModelType): InternalBusinessUnitList {
        const state: Object = Object.assign({}, json);
        state.businessUnits = Immutable.List(state.businessUnits).map(item =>
            InternalBusinessUnit.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }
}

class InternalBusinessUnit extends BusinessUnit {
    static fromJS(json: BusinessUnitModelType): InternalBusinessUnit {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

class InternalBusinessUnitId extends BusinessUnitId {
    static fromJS(json: BusinessUnitIdModelType): InternalBusinessUnitId {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

export {
    InternalBusinessUnitList as BusinessUnitList,
    InternalBusinessUnit as BusinessUnit,
    InternalBusinessUnitId as BusinessUnitId
};
